// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__eqoU+","container":"Info_container__6CBez","info":"Info_info__fSeGc","info2":"Info_info2__Q5TVy","map":"Info_map__9wK0s"};